/* PetLife – Campaña de ofertas con cuenta atrás.
   - El contador marca lo que falta para la fecha "Fin de la oferta" del editor
     (settings.campana_fin, hora de Chile, UTC−3). NO se reinicia: al llegar a cero
     se ocultan los relojes y el pop-up deja de aparecer. Sin fecha, no hay reloj.
     (Antes contaba hasta cada medianoche; se cambió el 2026-10-29 a pedido del
     usuario para no mostrar una urgencia que se repite todos los días.)
   - Pop-up: aparece a los X segundos según la frecuencia elegida en el editor
     (una vez por sesión, cada 6 horas o una vez al día) y respeta el cierre.
   - Ficha: el bloque de oferta solo se ve si la variante elegida tiene precio
     tachado y se esconde mientras la ficha muestre su propia cuenta atrás. */
(function () {
  if (window.mtCampanaLista) return;
  window.mtCampanaLista = true;

  // Fecha de término (la misma en la barra y el pop-up).
  var fin = null;
  var conFin = document.querySelector('[data-mt-campana-fin]');
  var finTxt = conFin ? (conFin.getAttribute('data-mt-campana-fin') || '').trim().replace(' ', 'T') : '';
  if (finTxt) {
    fin = new Date(finTxt + (finTxt.length === 16 ? ':00' : '') + '-03:00');
    if (isNaN(fin)) fin = null;
  }

  // Segundos que faltan para el fin de la oferta (0 si no hay fecha o ya pasó).
  function restante() {
    return fin ? Math.max(0, Math.floor((fin - new Date()) / 1000)) : 0;
  }
  function dos(n) { return (n < 10 ? '0' : '') + n; }

  function pintar() {
    var r = restante();
    if (r <= 0) {
      document.querySelectorAll('.mt-creloj, .mt-cbar__reloj, .mt-cflota__reloj').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
    }
    var h = dos(Math.floor(r / 3600)), m = dos(Math.floor((r % 3600) / 60)), s = dos(r % 60);
    var texto = h + ':' + m + ':' + s;
    document.querySelectorAll('[data-mt-diario]').forEach(function (el) {
      if (el.textContent !== texto) el.textContent = texto;
    });
    document.querySelectorAll('[data-mt-diario-h]').forEach(function (el) { el.textContent = h; });
    document.querySelectorAll('[data-mt-diario-m]').forEach(function (el) { el.textContent = m; });
    document.querySelectorAll('[data-mt-diario-s]').forEach(function (el) { el.textContent = s; });
  }

  // ---------- Bloque de la ficha ----------
  function revisarFichas() {
    document.querySelectorAll('[data-mt-campana-ficha]').forEach(function (bloque) {
      var pdp = bloque.closest('[data-mt-pdp]') || document;
      var was = pdp.querySelector('[data-mt-price-was]');
      var fin = pdp.querySelector('[data-mt-oferta-fin]');
      var hayDescuento = was ? !was.hidden : false;
      var otraCuenta = fin ? !fin.hidden : false;
      bloque.hidden = !hayDescuento || otraCuenta;
    });
  }

  // ---------- Pop-up ----------
  function iniciarPopup() {
    var el = document.getElementById('mt-campana-popup');
    if (!el) return;
    if (el.parentElement !== document.body) document.body.appendChild(el);
    var frecuencia = el.dataset.frecuencia || 'sesion';
    var retraso = (parseFloat(el.dataset.retraso) || 3) * 1000;
    var CLAVE = 'mtCampanaPopup';

    function hoyChile() {
      try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); }
    }
    function yaVisto() {
      try {
        if (frecuencia === 'sesion') return sessionStorage.getItem(CLAVE) === '1';
        var v = localStorage.getItem(CLAVE);
        if (!v) return false;
        if (frecuencia === 'dia') return v === hoyChile();
        return Date.now() < parseInt(v, 10);
      } catch (e) { return false; }
    }
    function marcar() {
      try {
        if (frecuencia === 'sesion') sessionStorage.setItem(CLAVE, '1');
        else if (frecuencia === 'dia') localStorage.setItem(CLAVE, hoyChile());
        else localStorage.setItem(CLAVE, String(Date.now() + 6 * 3600000));
      } catch (e) {}
    }

    var ultimoFoco = null;
    function abrir() {
      marcar();
      ultimoFoco = document.activeElement;
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      var b = el.querySelector('.mt-cpop__x');
      if (b) setTimeout(function () { b.focus({ preventScroll: true }); }, 60);
    }
    function cerrar() {
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; }, 300);
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
    }
    el.querySelectorAll('[data-mt-cpop-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) cerrar(); });

    if (yaVisto() || restante() <= 0) return;
    setTimeout(function () { if (el.hidden && !yaVisto() && restante() > 0) abrir(); }, retraso);
  }

  // ---------- Barra flotante ----------
  // Aparece abajo cuando la barra de arriba sale de la pantalla. Si se cierra, no vuelve
  // en esa visita. En la ficha (celular) se acomoda encima de la barra fija de compra.
  function iniciarFlotante() {
    var el = document.querySelector('[data-mt-cflota]');
    var barra = document.querySelector('.mt-topbar--campana');
    if (!el || !barra) return;
    var CLAVE = 'mtCampanaFlota';
    try { if (sessionStorage.getItem(CLAVE) === '1') return; } catch (e) {}
    if (el.parentElement !== document.body) document.body.appendChild(el);
    el.hidden = false;
    var cerrada = false;

    // Se mide la posición real: al bajar, la cabecera fija deja la barra justo arriba
    // del borde de la pantalla (top negativo), donde ya no se ve aunque "toque" el borde.
    var pendiente = false;
    function revisar() {
      pendiente = false;
      if (cerrada) return;
      var r = barra.getBoundingClientRect();
      var visible = r.bottom <= 6 || r.top >= window.innerHeight;
      el.classList.toggle('is-visible', visible);
      document.body.classList.toggle('mt-cflota-on', visible);
    }
    function alMover() {
      if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); }
    }
    window.addEventListener('scroll', alMover, { passive: true });
    window.addEventListener('resize', alMover);
    revisar();

    var compra = document.querySelector('[data-mt-sticky]');
    function subir() {
      var h = compra && compra.classList.contains('is-visible') && compra.offsetHeight ? compra.offsetHeight : 0;
      el.style.setProperty('--mt-cflota-sube', h + 'px');
    }
    if (compra) {
      new MutationObserver(subir).observe(compra, { attributes: true, attributeFilter: ['class', 'hidden'] });
      window.addEventListener('resize', subir);
      subir();
    }

    el.querySelector('[data-mt-cflota-cerrar]').addEventListener('click', function () {
      cerrada = true;
      el.classList.remove('is-visible');
      document.body.classList.remove('mt-cflota-on');
      try { sessionStorage.setItem(CLAVE, '1'); } catch (e) {}
      window.removeEventListener('scroll', alMover);
      window.removeEventListener('resize', alMover);
      setTimeout(function () { el.hidden = true; }, 300);
    });
  }

  function iniciar() {
    pintar();
    revisarFichas();
    iniciarPopup();
    iniciarFlotante();
    // Un solo reloj para todos los contadores; se alinea al cambio de segundo.
    setTimeout(function () { pintar(); setInterval(pintar, 1000); }, 1000 - (Date.now() % 1000));
    // Cambios de variante (el precio tachado aparece o desaparece) y fin de la cuenta propia de la ficha.
    var obs = new MutationObserver(revisarFichas);
    document.querySelectorAll('[data-mt-price-was], [data-mt-oferta-fin]').forEach(function (n) {
      obs.observe(n, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
